import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ImgDialogProps {
	img: string | null;
	onClose: () => void;
}

const ImgDialog: React.FC<ImgDialogProps> = ({ img, onClose }) => {
	const { translate } = useTranslate();
	return (
		<Modal show={!!img} onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>{translate('Extras.croppedImage')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{img && <img src={img} alt="Cropped" style={{ width: '100%' }} loading="lazy" />}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onClose}>
					{translate('Extras.close')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ImgDialog;
